import App from './App.vue'
import router from '@/plugins/router'
import '@hgj/element-plus/dist/index.css'
import '@/assets/index.scss'
import 'virtual:uno.css'
import '@stroybrooke-business-tools/components/es/style.css'
import '@hgj/storybrooke-business-tools/dist/index.css'
import registerDirectives from '@/directives'

import { i18n } from '@/plugins/i18n'
import { preLoad } from '@/preload'

if (window.__POWERED_BY_WUJIE__) {
  let instance: any
  window.__WUJIE_MOUNT = () => {
    const app = createApp(App)
    registerDirectives(app)
    app.use(i18n)
    app.use(router)
    app.use(createPinia())
    preLoad().then(() => {
      app.mount('#app')
    })
  }
  window.__WUJIE_UNMOUNT = () => {
    instance.unmount()
  }
  /*
    由于vite是异步加载，而无界可能采用fiber执行机制
    所以mount的调用时机无法确认，框架调用时可能vite
    还没有加载回来，这里采用主动调用防止用没有mount
    无界mount函数内置标记，不用担心重复mount
  */
  window.__WUJIE.mount()
} else {
  const app = createApp(App)
  registerDirectives(app)
  app.use(i18n)
  app.use(router)
  app.use(createPinia())
  preLoad().then(() => {
    app.mount('#app')
  })
}
